module.exports = __webpack_public_path__ + "static/media/swords-white.ed59a7c1.svg";